import { PagesItem } from 'components';
import { CICLO_FACTURACION_DETALLE } from 'navigation';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Routes from '../navigation/RouterConfig';

const RootAlzaEnergia = ({ path }: { path: string }) => {
  /**
   * history
   */
  const history = useHistory();
  /**
   * Uso del i18n para traducciones
   */
  const { t } = useTranslation();
  /**
   * Accion boton que retrocede a paso 1
   */
  const onClickVolver = () => {
    history.push(CICLO_FACTURACION_DETALLE);
  };

  return (
    <PagesItem
      titulo={t('tracking:paginas.tracking.cicloFacturacion.AlzaEnPrecioEnergia.titulo')}
      path={path}
      textoVolver={t('tracking:paginas.tracking.cicloFacturacion.AlzaEnPrecioEnergia.botonAtras')}
      onClickVolver={onClickVolver}
      dataTestId="pagina-principal"
    >
      <Routes />
    </PagesItem>
  );
};

export default RootAlzaEnergia;
